// src/modules/app-views/invoices/pages/Init/components/tableColumns/items/itemCestColumn.jsx
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import { Typography } from 'antd';
import { resolveItemFontSize } from './index';

const { Text } = Typography;

// *******************************************************************************
// COLUMN FUNCTION
// *******************************************************************************

// Renders the CEST (tax substitution specifier) column for item subtables.
function itemCestColumn(options = {}) {
  const { size, ..._ } = options;
  const fontSize = resolveItemFontSize(size, 10);
  return {
    title: 'CEST',
    dataIndex: ['tax', 'cest'],
    width: 70,
    align: 'center',
    sorter: (a, b) => {
      const aVal = a?.tax?.cest || a?.cest || '';
      const bVal = b?.tax?.cest || b?.cest || '';
      return aVal.localeCompare(bVal);
    },
    render: (_, item) => (
      <Text style={{ fontSize }} type="secondary">
        {item?.tax?.cest || item?.cest || '—'}
      </Text>
    ),
  };
}

export default itemCestColumn;
